/* eslint-disable max-len */
import React from 'react';

const NoImage = (
  <svg
    viewBox="0 0 999 834"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        x1="49.9946628%"
        y1="99.9937813%"
        x2="49.9946628%"
        y2="-0.000220870294%"
        id="linearGradient-1"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="undraw_blank_canvas_3rbb"
        transform="translate(0.000000, -1.000000)"
      >
        <path
          d="M323.83,30.66 C353.04,4.66 398.89,-0.67 440.63,1.4 C571.72,7.92 690.05,71.2 792.41,142.79 C829.47,168.7 865.95,196.63 890,232.32 C939,304.97 924.44,405.61 856.36,465.46 C833.19,485.82 805.11,501.46 776.28,515.27 C725.02,539.87 669.71,559.62 611.53,565.27 C570.05,569.27 528.05,566.02 486.8,560.43 C371.57,544.77 258.48,510.21 163.65,451.09 C122.07,425.16 82.88,392.92 65.74,350.99 C48.6,309.06 59.57,255.86 102.03,230.99 C119.59,220.72 140.59,216.08 161.14,211.72 C191.4,205.31 222.14,198.99 249.44,185.96 C277.65,172.5 311.04,146.47 305.44,116.67 C299.48,84.74 294.66,56.66 323.83,30.66 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M684.95,669.89 C684.95,669.89 710.01,625.5 747.74,612.71 C763.602163,607.445833 777.32899,597.178784 786.86,583.45 C791.334393,576.898058 795.197299,569.948846 798.4,562.69"
          id="Path"
          stroke="#535461"
          strokeWidth="2"
        />
        <path
          d="M822.14,554.48 C817.84,558.66 797.81,562.97 797.81,562.97 C797.81,562.97 802.72,543.08 807.02,538.91 C811.319537,534.734727 818.189727,534.835463 822.365,539.135 C826.540272,543.434537 826.439537,550.304727 822.14,554.48 L822.14,554.48 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M810.81,590.47 C804.93,591.64 785.81,584.38 785.81,584.38 C785.81,584.38 800.75,570.38 806.62,569.18 C812.499071,568.011918 818.211917,571.830929 819.38,577.71 C820.548082,583.589071 816.729071,589.301918 810.85,590.47 L810.81,590.47 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M769.56,629.41 C763.89,627.41 751.02,611.51 751.02,611.51 C751.02,611.51 771.02,606.95 776.66,608.91 C780.404435,610.114854 783.203512,613.251929 783.975549,617.108926 C784.747585,620.965923 783.371652,624.93869 780.379466,627.491981 C777.387281,630.045272 773.247534,630.779145 769.56,629.41 L769.56,629.41 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M731.71,651.85 C725.8,650.85 710.42,637.34 710.42,637.34 C710.42,637.34 729.33,629.46 735.24,630.44 C739.094251,631.038587 742.330614,633.659909 743.716694,637.305775 C745.102774,640.95164 744.425248,645.060939 741.942116,648.068863 C739.458985,651.076788 735.552409,652.520409 731.71,651.85 L731.71,651.85 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M769.07,568.84 C769.07,574.84 779.91,592.21 779.91,592.21 C779.91,592.21 790.77,574.84 790.77,568.85 C790.77,562.85771 785.91229,558 779.92,558 C773.92771,558 769.07,562.85771 769.07,568.85 L769.07,568.84 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M725.14,595.64 C726.94,601.36 742.48,614.7 742.48,614.7 C742.48,614.7 747.64,594.87 745.85,589.15 C744.057836,583.431092 737.968909,580.247837 732.25,582.040001 C726.531092,583.832165 723.347836,589.921092 725.14,595.64 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M686.02,627.54 C686.82,633.48 699.89,649.26 699.89,649.26 C699.89,649.26 708.33,630.59 707.53,624.65 C706.731948,618.710178 701.269822,614.54195 695.33,615.340001 C689.390178,616.138052 685.221949,621.600178 686.02,627.54 L686.02,627.54 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M797.81,562.97 C797.81,562.97 802.72,543.08 807.02,538.91 C811.319537,534.734727 818.189727,534.835463 822.365,539.135 C826.540272,543.434537 826.439537,550.304727 822.14,554.48 C817.84,558.66 797.81,562.97 797.81,562.97 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M810.81,590.47 C804.93,591.64 785.81,584.38 785.81,584.38 C785.81,584.38 800.75,570.38 806.62,569.18 C812.499071,568.011918 818.211917,571.830929 819.38,577.71 C820.548082,583.589071 816.729071,589.301918 810.85,590.47 L810.81,590.47 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M769.56,629.41 C763.89,627.41 751.02,611.51 751.02,611.51 C751.02,611.51 771.02,606.95 776.66,608.91 C780.404435,610.114854 783.203512,613.251929 783.975549,617.108926 C784.747585,620.965923 783.371652,624.93869 780.379466,627.491981 C777.387281,630.045272 773.247534,630.779145 769.56,629.41 L769.56,629.41 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M731.71,651.85 C725.8,650.85 710.42,637.34 710.42,637.34 C710.42,637.34 729.33,629.46 735.24,630.44 C739.094251,631.038587 742.330614,633.659909 743.716694,637.305775 C745.102774,640.95164 744.425248,645.060939 741.942116,648.068863 C739.458985,651.076788 735.552409,652.520409 731.71,651.85 L731.71,651.85 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M769.07,568.84 C769.07,574.84 779.91,592.21 779.91,592.21 C779.91,592.21 790.77,574.84 790.77,568.85 C790.77,562.85771 785.91229,558 779.92,558 C773.92771,558 769.07,562.85771 769.07,568.85 L769.07,568.84 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M725.14,595.64 C726.94,601.36 742.48,614.7 742.48,614.7 C742.48,614.7 747.64,594.87 745.85,589.15 C744.057836,583.431092 737.968909,580.247837 732.25,582.040001 C726.531092,583.832165 723.347836,589.921092 725.14,595.64 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M686.02,627.54 C686.82,633.48 699.89,649.26 699.89,649.26 C699.89,649.26 708.33,630.59 707.53,624.65 C706.731948,618.710178 701.269822,614.54195 695.33,615.340001 C689.390178,616.138052 685.221949,621.600178 686.02,627.54 L686.02,627.54 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M686.39,668.99 C686.39,668.99 691.31,618.25 720.63,591.27 C732.997024,580.026627 741.383356,565.075095 744.53,548.66 C745.969386,540.852552 746.685753,532.929006 746.670254,524.99"
          id="Path"
          stroke="#535461"
          strokeWidth="2"
        />
        <path
          d="M765.04,507.91 C762.8,513.47 746.24,525.53 746.24,525.53 C746.24,525.53 742.68,505.35 744.92,499.8 C746.300441,496.107588 749.574954,493.454388 753.473355,492.86958 C757.371755,492.284771 761.280641,493.860371 763.683753,496.985203 C766.086866,500.110035 766.606083,504.292417 765.04,507.91 L765.04,507.91 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M769.27,545.4 C764.37,548.85 743.91,549.97 743.91,549.97 C743.91,549.97 751.91,531.1 756.78,527.65 C759.950732,525.418876 764.0709,525.048799 767.588475,526.679171 C771.106051,528.309544 773.486632,531.692675 773.833475,535.554171 C774.180319,539.415668 772.440732,543.168876 769.27,545.4 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M747.34,597.72 C741.34,598.22 723.14,588.86 723.14,588.86 C723.14,588.86 739.55,576.6 745.48,576.09 C751.452959,575.587421 756.70242,580.022041 757.204999,585.995 C757.707578,591.967959 753.272959,597.21742 747.3,597.72 L747.34,597.72 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M721.83,633.57 C716.03,635.07 696.49,628.93 696.49,628.93 C696.49,628.93 710.58,614.06 716.38,612.56 C720.161551,611.497621 724.221996,612.562032 726.996069,615.342912 C729.770142,618.123793 730.824598,622.186834 729.752953,625.96577 C728.681309,629.744706 725.650929,632.649355 721.83,633.56 L721.83,633.57 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M722.35,542.53 C724.77,548.01 741.73,559.53 741.73,559.53 C741.73,559.53 744.62,539.25 742.19,533.77 C739.694058,528.412329 733.36899,526.038067 727.964067,528.429964 C722.559143,530.82186 720.063043,537.099844 722.35,542.55 L722.35,542.53 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M693.05,584.84 C697,589.34 716.62,595.24 716.62,595.24 C716.62,595.24 713.31,575.02 709.35,570.52 C706.813152,567.530843 702.861052,566.142749 699.012198,566.889058 C695.163343,567.635367 692.016471,570.399981 690.780688,574.120666 C689.544906,577.841351 690.412454,581.939309 693.05,584.84 L693.05,584.84 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M670.21,629.86 C673.35,634.97 691.69,644.09 691.69,644.09 C691.69,644.09 691.84,623.61 688.69,618.5 C686.660732,615.197079 683.023523,613.227657 679.148476,613.333595 C675.273428,613.439533 671.749254,615.604736 669.903475,619.013595 C668.057697,622.422453 668.170731,626.55708 670.2,629.86 L670.21,629.86 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="374.17"
          cy="815.05"
          rx="118.88"
          ry="19.93"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="608.16"
          cy="662.06"
          rx="118.88"
          ry="19.93"
        />
        <polygon
          id="Path"
          fill="#B77B7F"
          fillRule="nonzero"
          points="616.05 399.03 615.94 402.92 609.18 641.44 597.82 641.44 603.39 402.92 603.5 398.43"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="681.82 601.09 673.31 601.07 546.87 600.8 540.13 600.79 543.72 589.73 680.92 589.73"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="616.05 399.03 615.94 402.92 603.39 402.92 603.5 398.43"
        />
        <rect
          id="Rectangle"
          fill="#B77B7F"
          fillRule="nonzero"
          x="599.77"
          y="393.2"
          width="21.07"
          height="7.93"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="547.99 589.73 546.87 600.8 540.13 600.79 543.72 589.73"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="566.14 393.05 565.79 396.49 537.74 673.13 524.89 672.52 554.45 396.49 554.78 393.35"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="681.82 601.09 673.31 601.07 672.16 589.73 680.92 589.73"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="695.27 672.52 682.41 673.13 654.37 396.49 654.02 393.05 665.37 393.35 665.7 396.49"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="466.6"
          y="120.3"
          width="283.36"
          height="271.7"
        />
        <text
          id="Photo-not-found"
          fontFamily="AktivGrotesk-Medium, Aktiv Grotesk"
          fontSize="49"
          fontWeight="400"
          letterSpacing="0.2014182"
          fill="#515151"
        >
          <tspan x="543.047955" y="207">
            Photo{' '}
          </tspan>
          <tspan x="572.943373" y="263">
            not{' '}
          </tspan>
          <tspan x="544.297454" y="319">
            found
          </tspan>
        </text>
        <path
          d="M613.81,29.43 L613.81,95.04 L602.76,95.04 L602.76,29.43 C602.673619,27.400037 603.707377,25.48619 605.45239,24.4454492 C607.197403,23.4047084 609.372597,23.4047084 611.11761,24.4454492 C612.862623,25.48619 613.896381,27.400037 613.81,29.43 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="602.75"
          y="89.07"
          width="11.06"
          height="5.97"
        />
        <path
          d="M618.15,93.55 L618.15,115.21 L598.479981,115.21 L598.48,93.55 C598.47733,92.8357524 598.759882,92.1499879 599.264935,91.6449351 C599.769988,91.1398823 600.455752,90.8573299 601.17,90.86 L615.48,90.86 C616.95783,90.8709879 618.150041,92.0721296 618.15,93.55 L618.15,93.55 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <circle
          id="Oval"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          cx="608.28"
          cy="104.61"
          r="4.18"
        />
        <circle
          id="Oval"
          fill="#B77B7F"
          fillRule="nonzero"
          cx="608.28"
          cy="103.71"
          r="4.18"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="598.42"
          y="112.53"
          width="19.73"
          height="2.69"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="590.35"
          y="116.12"
          width="35.87"
          height="5.98"
        />
        <rect
          id="Rectangle"
          fill="#DDA2A6"
          fillRule="nonzero"
          x="590.35"
          y="114.32"
          width="35.87"
          height="5.98"
        />
        <path
          d="M535.72,385 L686.37,385 C689.959851,385 692.87,387.910149 692.87,391.5 L692.87,392.92 L529.22,392.92 L529.22,391.5 C529.22,387.910149 532.130149,385 535.72,385 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="554.78 393.35 566.14 393.05 565.79 396.49 554.45 396.49"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="599.77"
          y="393.2"
          width="21.07"
          height="3.29"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="665.7 396.49 654.37 396.49 654.02 393.05 665.37 393.35"
        />
        <path
          d="M535.72,386.77 L686.37,386.77 C689.959851,386.77 692.87,389.680149 692.87,393.27 L692.87,394.69 L529.22,394.69 L529.22,393.27 C529.22,391.546093 529.904819,389.892792 531.123806,388.673806 C532.342792,387.454819 533.996093,386.77 535.72,386.77 L535.72,386.77 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <path
          d="M502.69,260.63 C500.42,259.43 475.69,240.75 475.69,240.75 L435.78,215.44 C435.78,215.44 435.57,214.84 435.19,213.81 C446.14,201.38 443.75,183.34 432.61,170.66 C419.11,155.28 358.11,122.17 339.73,150.49 C337.16,154.49 337.07,159.03 336.4,163.43 C334.83,173.7 329.77,183.65 321.83,192.03 C315.71,198.5 307.68,204.46 304.16,211.78 C304.16,211.69 304.09,211.6 304.06,211.5 C303.210291,213.068894 302.593811,214.753268 302.23,216.5 C300.48,225.43 306.48,233.99 309.67,242.68 C310.740752,245.622791 311.517866,248.664258 311.99,251.76 C312.07,251.14 312.14,250.53 312.21,249.91 C312.987435,254.317993 313.252529,258.801103 313,263.27 C290.85,267.78 290.84,305.67 290.84,305.67 C290.84,305.67 288.11,320.73 288.57,326.16 C289.03,331.59 289.02,343.33 289.02,346.16 C289.02,348.99 286.29,366.64 286.02,368.76 C286.022652,368.789941 286.022652,368.820059 286.02,368.85 C285.62,371.17 281.47,382.35 291.5,384.85 C292.2,385.03 292.94,385.18 293.71,385.32 C294.14,394.37 294.92,413.32 294.23,417.54 C294.23,417.54 297.88,443 300.91,449.47 C302.826037,453.263744 305.067785,456.884 307.61,460.29 C307.389984,461.840277 306.866686,463.332017 306.07,464.68 C304.52,466.91 305.32,468.74 307.91,469.53 C307.82,470.3 307.72,471.17 307.61,472.15 C306.5,481.97 304.84,501.49 307.66,511.38 C311.53,524.94 311.76,529.46 311.76,529.46 C311.76,529.46 311.76,533.52 313.36,535.78 C314.96,538.04 317.91,559.06 317.91,562.45 C317.91,565.84 325.65,596.34 323.37,603.57 C321.09,610.8 322.92,620.97 322.92,620.97 C322.92,620.97 321.55,638.82 319.92,642.66 C318.29,646.5 317.64,708.41 320.14,724.45 C322.64,740.49 324.24,753.82 324.24,753.82 C324.24,753.82 322.65,768.51 324.01,770.54 C325.37,772.57 327.88,784.78 326.06,785.45 C324.24,786.12 323.33,791.1 323.33,791.1 C324.292457,792.563085 325.330532,793.975001 326.44,795.33 C325.738386,795.085118 325.053584,794.794494 324.39,794.46 C325.11,795.46 326.19,796.88 327.52,798.46 L326.27,814.71 C326.161664,816.018132 327.002991,817.217023 328.27,817.56 C336.405909,819.771552 345.098734,817.327416 350.89,811.2 C362.27,799.68 366.14,801.26 368.19,794.26 C368.41,793.51 368.6,792.77 368.76,792.07 C370.23,785.83 363.58,781.19 358.29,783.85 C359.02,778.91 359.59,773.3 359.04,770.13 C357.9,763.58 358.13,746.41 358.13,746.41 L356.54,664.16 C356.54,664.16 359.49,647.89 362.91,641.57 C366.33,635.25 365.91,613.1 365.91,613.1 L369.78,540.34 L373.42,504.87 C373.42,504.87 377.06,492.67 381.61,506.23 C381.61,506.23 379.11,533.56 380.25,540.12 C381.39,546.68 382.98,578.53 381.84,585.53 C380.7,592.53 375.7,630.95 378.84,640.66 C381.98,650.37 385.48,662.14 384.78,665.99 C384.08,669.84 381.78,753.2 381.78,753.2 C381.78,753.2 387.93,769.2 383.38,774.44 C378.83,779.68 383.15,800.44 383.15,800.44 C383.15,800.44 383.7,800.83 384.64,801.37 L384.51,803.1 L383.08,821.79 C382.974821,823.099523 383.813904,824.299412 385.08,824.65 C393.215919,826.863844 401.90992,824.419377 407.7,818.29 C419.08,806.76 422.95,808.35 425,801.34 C425.22,800.59 425.41,799.86 425.58,799.15 C427.18,792.34 419.08,787.4 413.66,791.85 L413.39,792.08 C413.106825,792.320713 412.809638,792.544438 412.5,792.75 C412.356169,792.855919 412.205878,792.952774 412.05,793.04 C413.19,787.88 414.85,779.04 414.05,774.9 C412.91,768.8 415.18,750.28 415.18,750.28 C415.18,750.28 421.78,728.13 422.01,719.28 L423.83,648.79 C423.83,648.79 423.61,620.09 424.52,613.09 C425.43,606.09 432.71,545.53 439.99,527.45 C445.58,513.61 448.08,478.29 446.6,460.38 C446.52,459.5 446.44,458.65 446.34,457.86 C455.27,451.27 456.16,440.31 456.16,440.31 C456.16,440.31 447.96,424.65 440.07,418.02 C432.18,411.39 430.48,399.99 430.76,395.14 C430.894033,392.184612 429.920546,389.285548 428.03,387.01 C428.03,387.01 424.39,375.26 421.96,374.06 C421.761224,373.95881 421.581818,373.823409 421.43,373.66 C419.78,371.89 421.05,366.83 421.05,366.83 L421.05,366.67 C421.34,365.5 423.05,357.92 422.54,355.98 C421.93,353.88 422.84,343.93 422.84,343.93 C422.84,343.93 428.61,326.76 427.7,313.2 C426.79,299.64 439.54,300.85 439.54,300.85 L478.91,300.44 L483.39,300.44 C484.969751,299.098592 486.4134,297.6047 487.7,295.98 C495.2,295.09 510.37,292.26 512.07,283.98 C514.38,272.99 504.97,261.84 502.69,260.63 Z M320.29,385.99 L320.56,379.1 C321.49,379.9 322.11,380.41 322.11,380.41 C322.612056,382.212735 322.636181,384.115114 322.18,385.93 C321.685244,387.656665 320.429661,389.063212 318.77,389.75 C318.579657,389.832743 318.395805,389.929683 318.22,390.04 L317.84,386.15 L320.29,385.99 Z M463.09,264.99 C461.42,264.24 455.8,264.39 452.91,264.39 C450.02,264.39 445.33,261.98 445.33,261.98 C444.33,260.03 438.8,258.87 433.88,258.21 C430.14,248.99 424.88,240 424.17,230.39 C424.17,230.04 424.17,229.69 424.12,229.34 L424.69,230.34 C424.69,230.34 447.61,244.96 450.19,249.34 C452.19,252.68 461.82,260.14 466.28,263.48 C465.665897,264.281209 464.80479,264.857623 463.83,265.12 C463.576001,265.147563 463.319396,265.102483 463.09,264.99 Z"
          id="Shape"
          fill="url(#linearGradient-1)"
          fillRule="nonzero"
        />
        <path
          d="M425.24,799.21 C425.07,799.91 424.89,800.64 424.67,801.38 C422.67,808.38 418.84,806.76 407.67,818.19 C401.997334,824.270495 393.42099,826.704374 385.4,824.51 C384.13205,824.17473 383.288418,822.976772 383.4,821.67 L384.81,803.13 L385.48,794.21 C385.48,794.21 403.32,799.21 412.4,792.86 C412.704615,792.651886 412.998335,792.428258 413.28,792.19 C413.350053,792.126808 413.416808,792.060053 413.48,791.99 C415.88272,790.000884 419.284735,789.760833 421.942966,791.392842 C424.601197,793.024851 425.926567,796.167259 425.24,799.21 L425.24,799.21 Z"
          id="Path"
          fill="#67647E"
          fillRule="nonzero"
        />
        <path
          d="M369.24,792.21 C369.07,792.91 368.89,793.64 368.67,794.38 C366.67,801.38 362.84,799.76 351.67,811.19 C345.997334,817.270495 337.42099,819.704374 329.4,817.51 C328.13205,817.17473 327.288418,815.976772 327.4,814.67 L328.81,796.13 L329.48,787.21 C329.48,787.21 347.32,792.21 356.4,785.86 C356.704615,785.651886 356.998335,785.428258 357.28,785.19 C357.350053,785.126808 357.416808,785.060053 357.48,784.99 C359.88272,783.000884 363.284735,782.760833 365.942966,784.392842 C368.601197,786.024851 369.926567,789.167259 369.24,792.21 Z"
          id="Path"
          fill="#67647E"
          fillRule="nonzero"
        />
        <path
          d="M350.81,794.99 L351.53,804.63 C341.29,814.86 329.1,799.63 325.53,794.63 C334.92,799.47 350.81,794.99 350.81,794.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M411,798.91 L412.34,798.02 C402.99,812.24 389.1,805.68 384.77,803.13 L385.44,794.21 C385.44,794.21 403.28,799.21 412.36,792.86 C411.65,796.34 411,798.91 411,798.91 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M439.48,529.68 C432.3,547.61 425.13,607.68 424.23,614.68 C423.33,621.68 423.56,650.1 423.56,650.1 L421.76,719.99 C421.53,728.74 415.03,750.71 415.03,750.71 C415.03,750.71 412.79,769.09 413.91,775.14 C415.03,781.19 411,797.14 411,797.14 L412.34,796.24 C401.13,813.24 383.42,800.5 383.42,800.5 C383.42,800.5 379.16,779.88 383.65,774.72 C388.14,769.56 382.08,753.65 382.08,753.65 C382.08,753.65 384.32,670.93 384.99,667.12 C385.66,663.31 382.3,651.65 379.16,642.01 C376.02,632.37 380.96,594.26 382.08,587.31 C383.2,580.36 381.63,548.75 380.51,542.25 C379.39,535.75 381.85,508.62 381.85,508.62 C377.37,495.17 373.78,507.28 373.78,507.28 L370.19,542.47 L366.38,614.66 C366.38,614.66 366.83,636.66 363.47,642.91 C360.11,649.16 357.19,665.32 357.19,665.32 L358.76,746.93 C358.76,746.93 358.54,763.93 359.66,770.46 C360.78,776.99 357.19,793.78 357.19,793.78 C344.64,823.35 324.48,791.29 324.48,791.29 C324.48,791.29 325.38,786.36 327.17,785.69 C328.96,785.02 326.5,772.91 325.17,770.89 C323.84,768.87 325.39,754.3 325.39,754.3 C325.39,754.3 323.82,741.08 321.39,725.16 C318.96,709.24 319.6,647.82 321.17,644.01 C322.74,640.2 324.08,622.49 324.08,622.49 C324.08,622.49 322.29,612.4 324.53,605.22 C326.77,598.04 319.15,567.79 319.15,564.42 C319.15,561.05 316.24,540.21 314.67,537.97 C313.1,535.73 313.1,531.69 313.1,531.69 C313.1,531.69 312.88,527.21 309.1,513.76 C306.32,503.94 307.96,484.58 309.05,474.83 C309.44,471.22 309.78,468.92 309.78,468.92 C309.78,468.92 438.35,448.07 443.48,452.78 C444.68,453.89 445.48,457.7 445.95,463.13 C447.48,480.89 444.96,515.99 439.48,529.68 Z"
          id="Path"
          fill="#444053"
          fillRule="nonzero"
        />
        <path
          d="M390.82,630.48 C391.42,630.48 405.62,631.68 410.82,630.63 C416.02,629.58 390.82,630.48 390.82,630.48 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M391.87,638.85 C391.87,638.85 411.48,642.29 412.48,640.5 C413.48,638.71 391.87,638.85 391.87,638.85 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M331.94,635.26 C331.94,635.26 342.1,635.71 347.63,638.26 C353.16,640.81 331.94,635.26 331.94,635.26 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M295.02,383.89 C295.02,383.89 296.66,415.12 295.77,420.65 C295.77,420.65 299.35,445.91 302.34,452.33 C305.33,458.75 311.76,466.83 311.76,466.83 L320.58,404.83 L318.48,383.59 L295.02,383.89 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <circle
          id="Oval"
          fill="#EFB7B9"
          fillRule="nonzero"
          cx="387.68"
          cy="207.09"
          r="34.52"
        />
        <path
          d="M369.75,223.22 C369.75,223.22 358.99,244.3 348.23,254.16 C337.47,264.02 412.79,275.23 414.58,275.23 C416.37,275.23 401.13,230.4 403.82,224.99 C406.51,219.58 369.75,223.22 369.75,223.22 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <path
          d="M445.97,463.13 C444.279644,464.42076 442.414299,465.464545 440.43,466.23 C426.69,471.61 411.74,479.08 401.58,476.1 C391.42,473.12 369.9,476.1 369.9,476.1 C369.9,476.1 326.55,472.51 317.9,474.6 C313.96,475.55 310.9,475.51 308.9,474.83 C309.29,471.22 309.63,468.92 309.63,468.92 C309.63,468.92 438.35,448.07 443.48,452.78 C444.7,453.89 445.48,457.7 445.97,463.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M455.38,443.21 C455.38,443.21 454.19,458.16 440.43,463.54 C426.67,468.92 411.74,476.39 401.58,473.41 C391.42,470.43 369.9,473.41 369.9,473.41 C369.9,473.41 326.55,469.82 317.9,471.91 C309.25,474 304.74,471.32 307.43,467.43 C310.12,463.54 309.83,450.69 309.83,445.31 C309.83,439.93 306.83,418.11 309.52,414.22 C312.21,410.33 314.6,395.39 319.98,392.99 C321.616324,392.300918 322.851992,390.907114 323.34,389.2 C323.784692,387.400667 323.760592,385.517364 323.27,383.73 C323.27,383.73 322.36,382.98 321.11,381.87 C317.94,379.04 312.58,373.79 314.3,372.07 C316.69,369.67 314.3,354.13 314.3,354.13 C314.3,354.13 308.62,342.18 310.72,337.7 C312.82,333.22 292.48,309.6 292.48,309.6 C292.48,309.6 292.48,268.96 316.99,267.16 C316.99,267.16 334.33,267.76 336.42,259.99 C338.51,252.22 352.26,247.73 352.26,247.73 L383.65,254.61 C383.65,254.61 411.44,260.61 416.53,257 C421.62,253.39 425.53,261.78 425.53,261.78 C425.53,261.78 442.86,262.68 444.65,266.27 C446.44,269.86 438.98,304.82 438.98,304.82 C438.98,304.82 426.42,303.63 427.32,317.08 C428.22,330.53 422.48,347.57 422.48,347.57 C422.48,347.57 421.58,357.43 422.18,359.52 C422.74,361.45 421,368.97 420.72,370.13 L420.72,370.28 C420.72,370.28 419.47,375.28 421.09,377.06 C421.240134,377.221047 421.415831,377.356198 421.61,377.46 C424.01,378.65 427.61,390.31 427.61,390.31 C429.476245,392.573421 430.434944,395.449516 430.3,398.38 C430.01,403.17 431.8,414.52 439.57,421.1 C447.34,427.68 455.38,443.21 455.38,443.21 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M322.07,373.99 L322.07,375.26 L321.53,389.26 C321.53,389.26 303.14,390.75 293.13,388.26 C283.12,385.77 287.33,374.66 287.73,372.36 C287.733662,372.330112 287.733662,372.299888 287.73,372.27 C288.02,370.17 290.73,352.69 290.73,349.85 C290.73,347.01 290.73,335.35 290.28,329.97 C289.83,324.59 292.48,309.6 292.48,309.6 L294.42,307.22 L315.48,315.29 L322.07,373.99 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M322.02,375.29 L321.48,389.29 C321.48,389.29 303.09,390.78 293.08,388.29 C283.07,385.8 287.28,374.69 287.68,372.39 L322.02,375.29 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M323.34,389.21 C323.784692,387.410667 323.760592,385.527364 323.27,383.74 C323.27,383.74 322.36,382.99 321.11,381.88 C336.94,379.67 399.63,371.07 420.74,370.13 L420.74,370.28 C420.74,370.28 419.49,375.28 421.11,377.06 L323.34,389.21 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M423.1,399.99 C423.1,399.99 426.99,421.99 412.489991,429.73011 C412.48,429.77 420.71,418.86 423.1,399.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M328.2,430.36 C328.2,430.36 363.2,424.36 370.05,429.02 C376.9,433.68 328.2,430.36 328.2,430.36 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M411,294.21 C411,294.21 405.62,316.33 409.65,321.41 C413.68,326.49 411,294.21 411,294.21 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M309.67,276.13 C309.67,276.13 314.6,284.35 311.61,292.87 C308.62,301.39 309.67,276.13 309.67,276.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M299.48,348.17 C299.48,348.17 305.76,351.9 303.67,357.73 C301.58,363.56 299.48,348.17 299.48,348.17 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M298.91,331.13 C298.91,331.13 304.73,334.27 305.48,338.9 C306.23,343.53 298.91,331.13 298.91,331.13 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M385.29,509.87 C385.29,509.87 421.91,513.61 429.23,504.94 C429.23,504.99 396.2,511.52 385.29,509.87 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M322.07,507.78 C322.07,507.78 361.38,517.05 369.15,509.72 C369.15,509.72 335.37,512.26 322.07,507.78 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M388.13,521.99 C388.13,521.99 404.57,521.99 412.19,522.44 C419.81,522.89 388.13,521.99 388.13,521.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M324.76,528.99 C324.76,528.99 332.83,538.11 341.95,536.47 C351.07,534.83 324.76,528.99 324.76,528.99 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M340.61,155.64 C338.08,159.57 337.99,164.12 337.33,168.48 C335.79,178.67 330.8,188.54 322.99,196.86 C315.82,204.48 305.99,211.39 304.13,220.7 C302.37,229.54 308.34,238.05 311.47,246.7 C319.72,269.39 308.2,293.19 304.84,316.61 C303.91,323.08 305.03,331.35 313,333.5 C315.49,334.18 318.34,334.09 320.58,335.17 C323.58,336.61 324.5,339.6 325.05,342.29 C327.055855,351.912177 327.748824,361.761756 327.11,371.57 C326.75,377.07 326.35,383.4 331.55,387.18 C333.91,388.91 337.09,389.79 340.16,390.62 C348.35,392.83 358.94,394.62 364.46,389.43 C366.78,387.26 367.65,384.2 370.54,382.48 C374.87,379.91 381.01,381.65 386.46,381.92 C397.65,382.48 407.93,375.92 412.34,368.01 C416.75,360.1 416.34,351.01 414.74,342.48 C413.14,333.95 410.28,325.48 410.08,316.82 C410.01,313.82 410.28,310.77 412,308.11 C415.33,302.96 423.08,300.62 428.38,296.57 C438.31,288.97 438.28,276.52 434.67,266.1 C431.06,255.68 424.58,245.69 423.78,234.92 C423.422961,232.316479 423.939979,229.668079 425.25,227.39 C426.67,225.2 429.15,223.56 431.25,221.75 C445.74,209.51 444.03,189.41 432.05,175.65 C418.79,160.4 358.71,127.55 340.61,155.64 Z"
          id="Path"
          fill="#E3787D"
          fillRule="nonzero"
        />
        <g
          id="Group"
          opacity="0.1"
          transform="translate(303.000000, 190.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <path
            d="M10.31,66.12 C11.44,57.03 11.23,48.02 8.02,39.17 C6.44,34.83 4.15,30.52 2.48,26.17 C1.64578599,27.742812 1.03970675,29.4263654 0.68,31.17 C-1.08,40.01 4.89,48.52 8.02,57.17 C9.07366763,60.0714253 9.84066142,63.0690648 10.31,66.12 Z"
            id="Path"
          />
          <path
            d="M23.66,164.04 C24.2971993,154.232219 23.6076408,144.383306 21.61,134.76 C21.05,132.07 20.13,129.09 17.13,127.65 C14.89,126.57 12.04,126.65 9.55,125.98 C6.44975579,125.236746 3.86639324,123.103627 2.55,120.2 C2.09,122.48 1.69,124.75 1.36,127.03 C0.43,133.5 1.55,141.77 9.52,143.92 C12.01,144.59 14.86,144.5 17.1,145.58 C20.1,147.02 21.02,150.01 21.58,152.7 C22.4973446,157.162908 23.1385618,161.678146 23.5,166.22 C23.57,165.48 23.61,164.76 23.66,164.04 Z"
            id="Path"
          />
          <path
            d="M108.9,160.49 C104.48,168.43 94.2,174.96 83.01,174.4 C77.56,174.12 71.42,172.4 67.1,174.96 C64.21,176.67 63.33,179.74 61.01,181.91 C55.49,187.06 44.9,185.31 36.71,183.1 C33.64,182.26 30.47,181.39 28.1,179.66 C25.8414146,177.99884 24.3173411,175.524462 23.85,172.76 C23.91,175.83 23.85,178.91 23.66,181.98 C23.3,187.48 22.9,193.81 28.1,197.6 C30.47,199.32 33.64,200.2 36.71,201.03 C44.9,203.24 55.49,205.03 61.01,199.84 C63.33,197.67 64.21,194.61 67.1,192.84 C71.42,190.27 77.56,192.01 83.01,192.28 C94.2,192.84 104.48,186.28 108.9,178.37 C113.14,170.73 112.95,162.09 111.47,153.84 C110.912512,156.16098 110.04824,158.397326 108.9,160.49 Z"
            id="Path"
          />
          <path
            d="M127.84,14.27 C125.7,16.07 123.22,17.72 121.84,19.91 C120.529979,22.1880786 120.012961,24.8364794 120.37,27.44 C120.660432,30.7123624 121.352294,33.9365733 122.43,37.04 C124.095348,35.263925 125.919609,33.6438471 127.88,32.2 C137.68,23.93 140.06,12.06 136.88,0.98 C135.202095,6.18456469 132.064309,10.7975267 127.84,14.27 Z"
            id="Path"
          />
          <path
            d="M124.93,89.04 C119.64,93.09 111.88,95.44 108.56,100.59 C106.83,103.25 106.56,106.32 106.63,109.29 C106.752967,112.787329 107.181262,116.267227 107.91,119.69 C108.099241,119.285382 108.316433,118.894436 108.56,118.52 C111.88,113.37 119.64,111.03 124.93,106.98 C134,100.04 134.76,89.06 132.08,79.27 C130.720307,83.1647257 128.231102,86.5660598 124.93,89.04 Z"
            id="Path"
          />
        </g>
        <path
          d="M482.28,300.34 C482.28,300.34 508.14,299 510.38,288.09 C512.62,277.18 503.38,266.09 501.12,264.92 C498.86,263.75 474.48,245.19 474.48,245.19 L435.18,220.09 C435.18,220.09 416.35,166.09 412.18,186.76 C408.01,207.43 424.29,234.88 424.29,234.88 C424.29,234.88 446.85,249.38 449.39,253.71 C451.93,258.04 467.48,269.4 467.48,269.4 L482.28,300.34 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <path
          d="M496.18,282.7 C490.06,298.25 482.13,304.38 482.13,304.38 L477.72,304.38 L438.95,304.78 L434.48,292.57 L440.76,266.11 L444.64,266.27 C444.64,266.27 449.28,268.66 452.11,268.66 C454.94,268.66 460.49,268.51 462.11,269.25 C462.33633,269.360548 462.591144,269.398945 462.84,269.36 C464.31,269.21 465.84,267.01 465.84,267.01 C465.84,267.01 502.31,267.16 496.18,282.7 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M496.18,282.7 C490.06,298.25 482.13,304.38 482.13,304.38 L477.72,304.38 C480.02,298.22 484.87,285.58 486.72,282.66 C488.53,279.9 472.29,273.03 462.79,269.32 C464.26,269.17 465.79,266.97 465.79,266.97 C465.79,266.97 502.31,267.16 496.18,282.7 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="90.82"
          cy="764.14"
          rx="44.18"
          ry="8.64"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="827.28"
          cy="707.15"
          rx="32.18"
          ry="6.29"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="966.77"
          cy="732.64"
          rx="32.18"
          ry="6.29"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="750.78"
          cy="785.14"
          rx="32.18"
          ry="6.29"
        />
        <path
          d="M132.57,524.3 C132.57,524.3 139.81,533.77 129.23,548.05 C118.65,562.33 109.94,574.39 113.48,583.3 C113.48,583.3 129.43,556.77 142.42,556.4 C155.41,556.03 146.86,540.26 132.57,524.3 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M132.57,524.3 C133.203413,525.224574 133.701761,526.23474 134.05,527.3 C146.72,542.19 153.47,556.08 141.29,556.43 C129.95,556.75 116.34,577.04 113.08,582.16 C113.184358,582.558084 113.314636,582.948918 113.47,583.33 C113.47,583.33 129.42,556.8 142.41,556.43 C155.4,556.06 146.86,540.26 132.57,524.3 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M146.02,536.36 C146.02,539.69 145.65,542.36 145.19,542.36 C144.73,542.36 144.35,539.66 144.35,536.36 C144.35,533.06 144.82,534.6 145.28,534.6 C145.74,534.6 146.02,532.99 146.02,536.36 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M150.64,540.34 C147.72,541.93 145.17,542.9 144.95,542.49 C144.73,542.08 146.95,540.49 149.84,538.87 C152.73,537.25 151.61,538.44 151.84,538.87 C152.07,539.3 153.56,538.74 150.64,540.34 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M94.36,524.3 C94.36,524.3 87.12,533.77 97.7,548.05 C108.28,562.33 116.99,574.39 113.48,583.3 C113.48,583.3 97.48,556.77 84.48,556.4 C71.48,556.03 80.07,540.26 94.36,524.3 Z"
          id="Path"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M94.36,524.3 C93.7265869,525.224574 93.2282385,526.23474 92.88,527.3 C80.21,542.19 73.46,556.08 85.64,556.43 C96.98,556.75 110.64,577.04 113.85,582.16 C113.744465,582.556549 113.617614,582.947117 113.47,583.33 C113.47,583.33 97.47,556.8 84.47,556.43 C71.47,556.06 80.07,540.26 94.36,524.3 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M80.91,536.36 C80.91,539.69 81.28,542.36 81.74,542.36 C82.2,542.36 82.58,539.66 82.58,536.36 C82.58,533.06 82.11,534.6 81.65,534.6 C81.19,534.6 80.91,532.99 80.91,536.36 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M76.29,540.34 C79.22,541.93 81.76,542.9 81.99,542.49 C82.22,542.08 79.99,540.49 77.09,538.87 C74.19,537.25 75.32,538.44 75.09,538.87 C74.86,539.3 73.37,538.74 76.29,540.34 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="113.46"
          cy="644.07"
          rx="75.65"
          ry="11.61"
        />
        <path
          d="M152.4,570.55 L152.04,573.55 L151.53,577.72 L151.32,579.46 L150.81,583.64 L150.59,585.38 L150.08,589.55 L144.3,636.99 C143.78,641.23 136.86,644.53 128.5,644.53 L98.48,644.53 C90.12,644.53 83.21,641.23 82.69,636.99 L76.9,589.54 L76.39,585.37 L76.18,583.63 L75.66,579.45 L75.45,577.71 L74.94,573.54 L74.58,570.54 C74.29,568.14 78.03,566.12 82.76,566.12 L144.28,566.12 C148.95,566.13 152.7,568.15 152.4,570.55 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="152.03 573.5 151.53 577.68 75.39 577.68 74.89 573.5"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="151.31 579.42 150.81 583.59 76.12 583.59 75.61 579.42"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="150.59 585.33 150.08 589.5 76.84 589.5 76.33 585.33"
        />
        <circle
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="179.99"
          cy="125.52"
          r="31.5"
        />
        <circle
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="113.99"
          cy="50.52"
          r="19.5"
        />
        <circle
          id="Oval"
          fill="#6C63FF"
          fillRule="nonzero"
          opacity="0.1"
          cx="12"
          cy="94.02"
          r="12"
        />
      </g>
    </g>
  </svg>
);

export default NoImage;
